window.axios = require('axios');

import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import ApiService from './common/api.service';
import _ from 'lodash';
import moment from 'moment';
moment.locale('pt-Br');

import './assets/sass/app.scss';
import 'animate.css';

import BootstrapVue from 'bootstrap-vue';
import 'bootstrap/dist/js/bootstrap.min.js'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
Vue.use(BootstrapVue)

import lodash from 'lodash'
import VueLodash from 'vue-lodash'
Vue.use(VueLodash, { lodash });

import VueParallaxJs from 'vue-parallax-js';
Vue.use(VueParallaxJs); // Registra o plugin

import VueCookies from 'vue-cookies';
// default options config: { expires: '1d', path: '/', domain: '', secure: '', sameSite: 'Lax' }
Vue.use(VueCookies, { expire: '7d' });

import Vuelidate from 'vuelidate';
Vue.use(Vuelidate);

//perfect scrollbar
import PerfectScrollbar from 'vue2-perfect-scrollbar';
Vue.use(PerfectScrollbar);

//vue-scrollactive
import VueScrollactive from 'vue-scrollactive';
Vue.use(VueScrollactive);

//vue-meta
import VueMeta from 'vue-meta';
Vue.use(VueMeta, {
    refreshOnceOnNavigation: true,
});

//Sweetalert
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
const options = {
    confirmButtonColor: '#4361ee',
    cancelButtonColor: '#e7515a',
};
Vue.use(VueSweetalert2, options);

//portal vue
import PortalVue from 'portal-vue';
Vue.use(PortalVue);

//vue-i18n
import i18n from './i18n';

import vSelect from 'vue-select';
Vue.component('v-select', vSelect);
import 'vue-select/dist/vue-select.css';

import Multiselect from 'vue-multiselect';
Vue.component('multiselect', Multiselect);
import 'vue-multiselect/dist/vue-multiselect.min.css';

import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/pt-br';
// https://mengxiong10.github.io/vue2-datepicker/index.html
// https://github.com/mengxiong10/vue2-datepicker
Vue.use(DatePicker);

import VueTheMask from 'vue-the-mask';
Vue.use(VueTheMask);

global.jQuery = require('jquery');
var $ = global.jQuery;
window.$ = $;

// set default settings
import appSetting from './app-setting';
Vue.prototype.$appSetting = appSetting;

//Maps CPV - Gilson- 12/09/2023
import * as VueGoogleMaps from 'vue2-google-maps';
Vue.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyDfvr7blbgOWNBtgVeJT-8hiF2cXmAm5Jg',
        libraries: ['places'],
    },
});




import VueYouTubeEmbed from 'vue-youtube-embed';
import { attempt } from 'lodash';
Vue.use(VueYouTubeEmbed, { global: true });

Vue.use(_);
ApiService.init();
appSetting.init();

Vue.prototype.$checkRole = function (value) {
    if (store.state.auth.user) {
        if (store.state.auth.user.role == value) {
            return true;
        } else {
            return false;
        }
    } else {
        return false;
    }
};

Vue.prototype.$checkPermission = function (value) {
    if (store.state.auth.userpermissions) {
        if (store.state.auth.userpermissions.includes(value)) {
            return true;
        } else {
            return false;
        }
    } else {
        return false;
    }
};
Vue.prototype.$checkSistemaCPVRole = function (value) {
    var found = false;
    for (var i = 0; i < this.userSistemaCPVRoles.length; i++) {
        if (this.userSistemaCPVRoles[i] == value) {
            found = true;
            break;
        }
    }
    return found;
};

Vue.prototype.$showToast = function (varTitle, varVariant, varMsg) {
    // Use a shorter name for this.$createElement
    const h = this.$createElement;
    // Create the message
    const vNodesMsg = h('p', { class: ['text-dark', 'mb-0'] }, [varMsg]);
    // Create the title
    const vNodesTitle = h('div', { class: ['d-flex', 'flex-grow-1', 'align-items-baseline', 'mr-2'] }, [
        h('strong', { class: 'mr-2' }, varTitle),
        h('small', { class: 'ml-auto text-italics' }, moment().format('h:mm:ss')),
    ]);
    // Pass the VNodes as an array for message and title
    this.$bvToast.toast([vNodesMsg], {
        title: [vNodesTitle],
        solid: true,
        variant: varVariant,
        autoHideDelay: 10000,
    });
};

Vue.filter('formatShortDate', function (value) {
    if (!value) return 'Data inválida';

    const date = moment(value.trim(), 'DD/MM/YYYY HH:mm:ss', true);

    if (date.isValid()) {
        return date.format('DD/MM/YYYY')
        // Tentativa de forçar a conversão da string de data para o formato esperado
    } else {
        // Tentativa de forçar o formato sem hora, caso a data original não inclua hora
        const dateWithoutTime = moment(value.trim(), 'DD/MM/YYYY', true);

        if (dateWithoutTime.isValid()) {
            return dateWithoutTime.format('DD/MM/YYYY');
        } else {
            const isoDate = moment(value)
            if (isoDate.isValid()) {
                return isoDate.format('DD/MM/YYYY')
            }
        }
    }
});
Vue.filter('formatDateTime', function (value) {
    if (value) {
        return moment(value).format('DD/MM/YYYY HH:mm');
    } else {
        return null;
    }
});
Vue.filter('translateInterval', function (value) {
    if (value == 'months') {
        return 'Mensal';
    } else if (value == 'weeks') {
        return 'Semanal';
    } else {
        return null;
    }
});
Vue.filter('formatPrice', function (value) {
    if (value && value > 0) {
        let val = (value / 100).toFixed(2).replace('.', ',');
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    } else {
        return '0,00';
    }
});
Vue.filter('formatPriceOriginalDecimal', function (value) {
    if (value && value > 0) {
        let val = Number(value).toFixed(2).replace('.', ',');
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    } else {
        return '0,00';
    }
});

Vue.filter('formatPercent', function (value) {
    if (value && value > 0) {
        let val = Number(value) * 100;

        return val.toFixed(2).replace('.', ',');
    } else {
        return '0';
    }
});
Vue.filter('translatePayable', function (value) {
    const options = [
        { id: 'all', name: 'Cartão, Boleto ou Pix' },
        { id: 'credit_card', name: 'Cartão de Crédito' },
        { id: 'bank_slip', name: 'Boleto Bancário' },
        { id: 'pix', name: 'Pix' },
    ];
    const obj = options.find((item) => item.id === value);
    if (obj) {
        return obj.name;
    } else {
        return null;
    }
});

new Vue({
    router,
    store,
    i18n,
    render: (h) => h(App),
}).$mount('#app');
